import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "../TiterForm/titer.css"; // Import custom styles
import animalHealth from "../../images/AnimalHealth.png";
import ukas from "../../images/UKAS1.jpg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const TiterForm = () => {
  const location = useLocation();

  // console.log("Location State:", location.state); // Debugging

  const Relocation_Id = location.state?.Relocation_Id; // Get Relocation_Id from route state
  // console.log("Received Relocation_Id:", Relocation_Id); // Debugging

  const downloadAsPDF = () => {
    const input = document.getElementById("pdf-content");

    html2canvas(input, {
      scale: 3, // Increase the scale for higher resolution
      useCORS: true, // Ensure cross-origin images are rendered
      backgroundColor: "#ffffff", // Explicitly set background to white to avoid transparency issues
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0); // Use 1.0 for best quality
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = 210;
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("Estimate.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };
  const baseAPI = process.env.REACT_APP_API_URL;

  // Fetch data and populate the form
  useEffect(() => {
    const fetchRows = async () => {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (!Relocation_Id) {
          console.error("Relocation_ID is not defined");
          alert("Relocation_ID is not available. Please check the data.");
          return;
        }

        const response = await axios.get(
          `${baseAPI}userget/GetAnimalTiterForm?relocation_id=${Relocation_Id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response.data.status === "True" && response.data.data.length > 0) {
          // console.log(response.data.data[0]); // Debugging API response

          setFormData((prevData) => ({
            ...prevData,
            ...response.data.data[0], // Correctly mapping the first object in "data" array
          }));
        } else {
          console.warn("No data found for this Relocation_Id");
        }
      } catch (error) {
        console.error("Error fetching rows data:", error);
      }
    };

    fetchRows();
  }, [Relocation_Id, baseAPI]);

  const [error, setError] = useState("");

  const [isEditing, setIsEditing] = useState(false);

  // Form the request payload
  const [formData, setFormData] = useState({
    relocation_id: Relocation_Id,
    practice_name: "",
    practice_postcode: "",
    practice_address: "",
    practiceTelephoneNumber: "",
    practice_email: "",
    practice_reduced_titration: false,
    practice_full_titration: false,
    practice_report_by_post: false,
    practice_report_by_courier: false,
    practice_report_charging: false,
    practice_extra_reports_email: "",
    practice_extra_reports_post: false,
    practice_extra_reports_courier: false,
    peport_email_address: "",
    practice_report_address2: "",
    practice_report_postcode2: "", // Map this if available in the frontend
    practice_name_blockletters: "",
    practice_date: "",
    owner_name: "",
    owner_address: "",
    owner_postcode: "",
    owner_email: "",
    animal_name: "",
    owner_microchip_number: "", // Join microchip segments as a single string
    owner_avid_microchip_number: "",
    owner_species: "",
    owner_breed: "",
    owner_age: "",
    owner_sex: "",
    owner_date_of_sampling: "",
    owner_date_of_vaccination: "",
    owner_vaccine_manufacturer: "",
    owner_date_of_travel: "",
    owner_destination_country: "",
    created_date: "", // Current creation date
    createdBy: "Mukul", // Set appropriate user name if available
    modified_date: null,
    modifiedBy: null,
  });

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    if (type === "checkbox") {
      // If checkbox is checked, set value to 1, otherwise set it to 0
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value, // ✅ Ensure checkbox values are boolean
      }));
    } else {
      // For other input types, handle normally
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // // Basic validation for required fields
  // if (!practice_name || !practice_address || !practice_postcode || !practiceTelephoneNumber || !practice_email) {
  //   setError("All fields are required.");
  //   return;
  // }

  // Helper function to join microchip segments into a single string
  const handleMicrochipChange = (e, groupIndex, inputIndex) => {
    const { value } = e.target;
    const updatedMicrochipNumber = [
      ...formData.owner_microchip_number.split(","),
    ];

    // Update the specific segment of the microchip number
    updatedMicrochipNumber[groupIndex * 3 + inputIndex] = value;

    // Join the segments back into a string
    setFormData({
      ...formData,
      owner_microchip_number: updatedMicrochipNumber.join(","),
    });
  };

  // Helper function to handle AVID microchip number change
  const handleAvidMicrochipChange = (e, groupIndex, inputIndex) => {
    const { value } = e.target;
    const updatedAvidMicrochipNumber = [
      ...formData.owner_avid_microchip_number.split(","),
    ];

    // Update the specific segment of the AVID microchip number
    updatedAvidMicrochipNumber[groupIndex * 3 + inputIndex] = value;

    // Join the segments back into a string with commas separating them
    setFormData({
      ...formData,
      owner_avid_microchip_number: updatedAvidMicrochipNumber.join(","),
    });
  };


  // data send
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}UserPost/TiterTestForm`,
        formData, // Send the payload (as JSON)
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json", // JSON content type for a regular API call
          },
        }
      );
      setFormData({
        practice_name: "",
        practice_postcode: "",
        practice_address: "",
        practiceTelephoneNumber: "",
        practice_email: "",
        practice_reduced_titration: false,
        practice_full_titration: false,
        practice_report_by_post: false,
        practice_report_by_courier: false,
        practice_report_charging: false,
        practice_extra_reports_email: "",
        practice_extra_reports_post: false,
        practice_extra_reports_courier: false,
        peport_email_address: "",
        practice_report_address2: "",
        practice_report_postcode2: "", // Map this if available in the frontend
        practice_name_blockletters: "",
        practice_date: "",
        owner_name: "",
        owner_address: "",
        owner_postcode: "",
        owner_email: "",
        animal_name: "",
        owner_microchip_number: "", // Join microchip segments as a single string
        owner_avid_microchip_number: "",
        owner_species: "",
        owner_breed: "",
        owner_age: "",
        owner_sex: "",
        owner_date_of_sampling: "",
        owner_date_of_vaccination: "",
        owner_vaccine_manufacturer: "",
        owner_date_of_travel: "",
        createdBy: "",
      });
      if (response.data.status === "True") {
        alert("Practice information submitted successfully!");
      } else {
        alert(`Submission failed: ${response.data.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(
        `An error occurred while submitting the form. Please try again.\nError: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  return (
    <>
      <div className="titer-form-container" id="pdf-content">
        <header className="form-header">
          <div className="logo">
            <img src={animalHealth} alt="Logo" />
          </div>
          <div className="header-info">
            <p style={{ padding: "9px 0 0 0", lineHeight: "1.3" }}>
              <span style={{ fontSize: "13px", fontWeight: 600 }}>
                Rabies Serology | Sample Reception
              </span>
              <br />
              <span style={{ fontSize: "13px", fontWeight: 600 }}>
                APHA Weybridge
              </span>
              <br />
              Woodham Lane, New Haw,
              <br />
              Addlestone, Surrey KT15 3NB
              <br />
              Tel: 03000 600002 | Email: lab.services@apha.gov.uk
              <br />
              {/* <a href="http://www.gov.uk/apha"> */}
              Web: www.gov.uk/apha
              {/* </a> */}
            </p>
          </div>
          <div className="reference-box">
            <p className="titer-p">APHA USE ONLY</p>
            <div className="reference-titer-div">
              <p className="reference-titer-div-p">Date Received</p>
              <p></p>
            </div>

            <p
              className="reference-titer-div-p2"
              style={{ textAlign: "center", color: "lightgray" }}
            >
              APHA SUBMISSION REFERENCE
              {/* <span>APHA SUBMISSION REFERENCE</span> */}
            </p>
          </div>
        </header>
        <span className="reference-span">
          Request for determination of antibodies against rabies
        </span>
        <main className="form-content">
          {error && <div className="error-message">{error}</div>}
          <section className="section">
            <div className="form-section">
              <div className="div-h3">
                 <h3 className="titer-form-h3ms">Submitting Veterinary Practice</h3>
              </div>
              <label style={{ fontSize: "14px", paddingBottom: "1px" }}>
                Practice Name:
              </label>
              {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="practice_name"
                  value={formData.practice_name}
                  onChange={handleChange}
                  className="titer-pvalue practice-the-all-ms"
                />
              ) : (
                <div className="titer-pvalue practice-the-all-ms">
                  {formData.practice_name}
                </div>
              )}

              <label style={{ fontSize: "14px", paddingBottom: "1px" }}>
                Address:
              </label>
              <div
                className="titer-pvalue-div"
                style={{ width: "100%", height: "fitContent" }}
              >
                {isEditing ? (
                  <textarea
                    id="practice_address"
                    className="titer-pvalue"
                    value={formData.practice_address}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        practice_address: e.target.value,
                      })
                    }
                    style={{
                      minHeight: "64px",
                      width: "99.5%",
                      border: "1px solid black",
                      padding: "2px",
                      margin: "1px 1px -2px 1px",
                      fontSize: "14px",
                      lineHeight: "1",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  />
                ) : (
                  <div
                    id="practice_address"
                    className="titer-pvalue"
                    style={{
                      minHeight: "64px",
                      width: "99.5%",
                      border: "1px solid black",
                      padding: "2px",
                      margin: "1px 1px -2px 1px",
                      fontSize: "14px",
                      lineHeight: "1",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      cursor: "pointer",
                    }}
                  >
                    {formData.practice_address}
                  </div>
                )}
                <label style={{ height: "31px" }}>
                  Postcode:
                  {isEditing ? (
                    <input
                      type="text"
                      placeholder=""
                      name="practice_postcode"
                      className="titer-pvalue-div-2"
                      value={formData.practice_postcode}
                      onChange={handleChange}
                    />
                  ) : (
                    <div className="titer-pvalue-div-2">
                      {formData.practice_postcode}
                    </div>
                  )}
                </label>
              </div>
              <label style={{ fontSize: "14px", padding: "0 0 4px 0" }}>
                Telephone Number{" "}
                <span style={{ fontSize: "10.64px" }}>
                  (inc.international dialling code)
                </span>
              </label>
              {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="practiceTelephoneNumber"
                  className="titer-pvalue practice-the-all-ms"
                  value={formData.practiceTelephoneNumber}
                  onChange={handleChange}
                />
              ) : (
                <div className="titer-pvalue practice-the-all-ms">
                  {formData.practiceTelephoneNumber}
                </div>
              )}
              <label style={{ padding: "3px 0 3px 0", fontSize: "14px" }}>
                Email Address
              </label>
              {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="practice_email"
                  className="titer-pvalue practice-the-all-ms"
                  value={formData.practice_email}
                  onChange={handleChange}
                />
              ) : (
                <div className="titer-pvalue practice-the-all-ms">
                  {formData.practice_email}
                </div>
              )}
              <div
                style={{ margin: "9px 0 0 0", border: "2px solid #000" }}
              ></div>
              <label style={{ fontWeight: 600, fontSize: "16px" }}>
                Test Required
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex" }}>
                  <p style={{ fontSize: "12px" }}>TC0712 Reduced Titration#</p>
                  <span style={{ padding: "0 0 0 13px" }}>
                    {" "}
                    <input
                      type="checkbox"
                      name="practice_reduced_titration"
                      className="custom-checkbox"
                      checked={!!formData.practice_reduced_titration}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        appearance: "none",
                        backgroundColor: "#ffffff",
                        display: "inline-block",
                        position: "relative",
                        cursor: isEditing ? "pointer" : "not-allowed",
                      }}
                    />
                  </span>{" "}
                </div>
                <div style={{ display: "flex" }}>
                  <p style={{ fontSize: "12px" }}>TC0712 Full Titration</p>
                  <span style={{ padding: "0 0 0 19px" }}>
                    <input
                      type="checkbox"
                      name="practice_full_titration"
                      className="custom-checkbox"
                      checked={!!formData.practice_full_titration}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        cursor: isEditing ? "pointer" : "not-allowed"
                      }}
                    />
                  </span>{" "}
                </div>
              </div>
              <p
                style={{
                  fontSize: "10.64px",
                  marginBottom: "-9px",
                  marginTop: "-7px",
                }}
              >
                #Suitable for Pet Travel Schemes including the Eu and Australia
              </p>
              <div
                style={{ margin: "9px 0 0 0", border: "2px solid #000" }}
              ></div>
              <div>
                <p style={{ fontSize: "14.5px", marginBottom: "-4px" }}>
                  Your report will be emailed to you free of charge.{" "}
                </p>
                <p style={{ fontSize: "14.5px", marginBottom: "-4px" }}>
                  Please indicate if you would also like your report sent:
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingTop: "4px",
                }}
              >
                <div style={{ display: "flex" }}>
                  <p style={{ fontSize: "12px", fontWeight: 600 }}>By Post*</p>
                  <span style={{ padding: "0 0 0 5px" }}>
                    <input
                      type="checkbox"
                      name="practice_report_by_post"
                      className="custom-checkbox"
                      checked={!!formData.practice_report_by_post}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        cursor: isEditing ? "pointer" : "not-allowed"
                      }}
                    />
                  </span>{" "}
                </div>
                <div style={{ display: "flex" }}>
                  <p style={{ fontSize: "12px", fontWeight: 600 }}>
                    By Courier*
                  </p>
                  <span style={{ padding: "0 0 0 3px" }}>
                    <input
                      type="checkbox"
                      name="practice_report_by_courier"
                      className="custom-checkbox"
                      checked={!!formData.practice_report_by_courier}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        cursor: isEditing ? "pointer" : "not-allowed"
                      }}
                    />
                  </span>{" "}
                </div>
                <div style={{ display: "flex" }}>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      padding: "0 3px 0 0",
                    }}
                  >
                    Without charging preview*
                  </p>
                  <span style={{ padding: "0 0 0 0px" }}>
                    <input
                      type="checkbox"
                      name="practice_report_charging"
                      className="custom-checkbox"
                      checked={!!formData.practice_report_charging}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        cursor: isEditing ? "pointer" : "not-allowed"
                      }}
                    />
                  </span>{" "}
                </div>
              </div>

              <div
                style={{ margin: "-7px 0 0 0", border: "2px solid #000" }}
              ></div>
              <p style={{ margin: "0", fontSize: "13px" }}>
                Are any extra reports required?
              </p>
              <div style={{ display: "flex" }}>
                <p style={{ fontSize: "12px", fontWeight: 600 }}>E-mail</p>
                <span style={{ padding: "0 0 0 8px" }}>
                  <input
                    type="checkbox"
                    name="practice_extra_reports_email"
                    className="custom-checkbox"
                    checked={!!formData.practice_extra_reports_email}
                    onChange={handleChange}
                    disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        cursor: isEditing ? "pointer" : "not-allowed"
                      }}
                  />
                </span>{" "}
              </div>
              <div style={{ display: "flex" }}>
                <label style={{ padding: "3px 10px 2px 0", fontSize: "12px" }}>
                  Email Address
                </label>
                {isEditing ? (
                  <input
                    type="text"
                    placeholder=""
                    name="peport_email_address"
                    className="titer-pvalue"
                    value={formData.peport_email_address}
                    onChange={handleChange}
                    style={{ fontSize: "14px", width: "76%" }}
                  />
                ) : (
                  <div
                    className="titer-pvalue"
                    style={{ fontSize: "14px", width: "76%" }}
                  >
                    {formData.peport_email_address}
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  paddingTop: "3px",
                }}
              >
                <div style={{ display: "flex" }}>
                  <p style={{ fontSize: "12px", fontWeight: 600 }}>Post*</p>
                  <span style={{ padding: "0 36px 0 5px" }}>
                    <input
                      type="checkbox"
                      name="practice_extra_reports_post"
                      className="custom-checkbox"
                      checked={!!formData.practice_extra_reports_post}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        cursor: isEditing ? "pointer" : "not-allowed"
                      }}
                    />
                  </span>{" "}
                </div>
                <div style={{ display: "flex" }}>
                  <p style={{ fontSize: "12px", fontWeight: 600 }}>Courier*</p>
                  <span style={{ padding: "0 0 0 3px" }}>
                    <input
                      type="checkbox"
                      name="practice_extra_reports_courier"
                      className="custom-checkbox"
                      checked={!!formData.practice_extra_reports_courier}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        cursor: isEditing ? "pointer" : "not-allowed"
                      }}
                    />
                  </span>{" "}
                </div>
              </div>
              <label
                style={{
                  fontSize: "14px",
                  marginTop: "-7px",
                  paddingBottom: "1px",
                }}
              >
                Address:
              </label>
              <div className="titer-pvalue-div">
                {isEditing ? (
                  <textarea
                    id="practice_report_address2"
                    className="titer-pvalue"
                    value={formData.practice_report_address2}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        practice_report_address2: e.target.value,
                      })
                    }
                    style={{
                      minHeight: "64px",
                      width: "99.5%",
                      border: "1px solid black",
                      padding: "2px",
                      margin: "1px 1px -2px 1px",
                      fontSize: "14px",
                      lineHeight: "1",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  />
                ) : (
                  <div
                    id="practice_report_address2"
                    className="titer-pvalue"
                    style={{
                      minHeight: "64px",
                      width: "99.5%",
                      border: "1px solid black",
                      padding: "2px",
                      margin: "1px 1px -2px 1px",
                      fontSize: "14px",
                      lineHeight: "1",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      cursor: "pointer",
                    }}
                  >
                    {formData.practice_report_address2}
                  </div>
                )}
                <label style={{ height: "31px" }}>
                  Postcode:{" "}
                  {isEditing ? (
                    <input
                      type="text"
                      placeholder=""
                      name="practice_report_postcode2"
                      className="titer-pvalue-div-2"
                      value={formData.practice_report_postcode2}
                      onChange={handleChange}
                    />
                  ) : (
                    <div className="titer-pvalue-div-2">
                      {formData.practice_report_postcode2}
                    </div>
                  )}
                </label>
              </div>
              <p
                style={{
                  fontSize: "11px",
                  fontWeight: 600,
                  fontStyle: "italic",
                  lineHeight: 1,
                  marginBottom: "-1px",
                  paddingTop: "1px",
                }}
              >
                *Please note that there will be an additional charge for these
                services (TC0802 – additional or postal report)
              </p>
              <div
                style={{ margin: "7px 0 0 0", border: "2px solid #000" }}
              ></div>
              <p style={{ fontWeight: 600, fontSize: "16px" }}>
                Signature of Submitting Veterinary Surgeon
              </p>
              <div
                style={{ margin: "-11px 0 10px 0", border: "2px solid #000" }}
              ></div>
              <input
                type="text"
                style={{ width: "100%", border: "0.4px solid" }}
              ></input>

              <label style={{ fontSize: "14px", padding: "0px 0 1px 0" }}>
                Name in BLOCK letters
              </label>
              {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  className="titer-pvalue practice-the-all-ms"
                  name="practice_name_blockletters"
                  value={formData.practice_name_blockletters}
                  onChange={handleChange}
                />
              ) : (
                <div className="titer-pvalue practice-the-all-ms">
                  {formData.practice_name_blockletters}
                </div>
              )}
              <div style={{ display: "flex", padding: "7px 0 0 0" }}>
                <label style={{ padding: "3px 8px 2px 0", fontSize: "12px" }}>
                  Date
                </label>
                {isEditing ? (
                  <input
                    type="text"
                    placeholder=""
                    className="titer-pvalue"
                    name="practice_date"
                    value={formData.practice_date}
                    onChange={handleChange}
                    style={{ fontSize: "14px", width: "91%" }}
                  />
                ) : (
                  <div
                    className="titer-pvalue"
                    style={{ fontSize: "14px", width: "91%" }}
                  >
                    {formData.practice_date}
                  </div>
                )}
              </div>
              <div
                style={{ margin: "8px 0 0 0", border: "2px solid #000" }}
              ></div>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  marginBottom: "-1px",
                }}
              >
                Invoicing and Payments
              </p>
              <div
                style={{ margin: "3px 0 0 0", border: "2px solid #000" }}
              ></div>
              <p
                style={{
                  fontSize: "13.6px",
                  fontWeight: 600,
                  lineHeight: 1.2,
                  border: "0.4px solid",
                  padding: "2px 4px 2px 4px",
                }}
              >
                The submitting Veterinary Practice will be invoiced for testing
                and are responsible for all payments. If you would like a third
                party to pay for testing, you will need to facilitate this
                yourselves.{" "}
              </p>
            </div>

            <div
              className="linediv"
              style={{ height: "57.5rem", marginTop: "-7px" }}
            ></div>

            <div className="form-section">
              <div className="div-h3">
                 <h3 className="titer-form-h3ms">Owner's Name and Address</h3>
              </div>
              <label>Owner's Name:</label>
              {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="owner_name"
                  className="titer-pvalue practice-the-all-ms"
                  value={formData.owner_name}
                  onChange={handleChange}
                />
              ) : (
                <div className="titer-pvalue practice-the-all-ms">
                  {formData.owner_name}
                </div>
              )}
              <label
                style={{
                  fontSize: "14px",
                  marginTop: "6px",
                  paddingBottom: "1px",
                }}
              >
                Address:
              </label>
              <div className="titer-pvalue-div">
                {isEditing ? (
                  <textarea
                    id="owner_address"
                    className="titer-pvalue"
                    value={formData.owner_address}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        owner_address: e.target.value,
                      })
                    }
                    style={{
                      minHeight: "64px",
                      width: "99.5%",
                      border: "1px solid black",
                      padding: "2px",
                      margin: "1px 1px -2px 1px",
                      fontSize: "14px",
                      lineHeight: "1",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  />
                ) : (
                  <div
                    id="owner_address"
                    className="titer-pvalue"
                    style={{
                      minHeight: "64px",
                      width: "99.5%",
                      border: "1px solid black",
                      padding: "2px",
                      margin: "1px 1px -2px 1px",
                      fontSize: "14px",
                      lineHeight: "1",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      cursor: "pointer",
                    }}
                  >
                    {formData.owner_address}
                  </div>
                )}

                <label style={{ height: "31px" }}>
                  Postcode:{" "}
                  {isEditing ? (
                    <input
                      type="text"
                      placeholder=""
                      name="owner_postcode"
                      value={formData.owner_postcode}
                      onChange={handleChange}
                      className="titer-pvalue-div-2"
                    />
                  ) : (
                    <div className="titer-pvalue-div-2">
                      {formData.owner_postcode}
                    </div>
                  )}
                </label>
              </div>

              <label style={{ padding: "3px 0 6px 0", fontSize: "14px" }}>
                Email Address
              </label>
              {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="owner_email"
                  className="titer-pvalue practice-the-all-ms"
                  value={formData.owner_email}
                  onChange={handleChange}
                />
              ) : (
                <div className="titer-pvalue practice-the-all-ms">
                  {formData.owner_email}
                </div>
              )}
              <div
                style={{ margin: "7px 0 0 0", border: "2px solid #000" }}
              ></div>
              <p
                style={{
                  fontWeight: 600,
                  fontSize: "15px",
                  paddingBottom: "1px",
                }}
              >
                Animal Details
              </p>
              <div
                style={{ margin: "-11px 0 0px 0", border: "2px solid #000" }}
              ></div>
              <label style={{ padding: "3px 0 2px 0", fontSize: "14px" }}>
                Animal's Name
              </label>
              {isEditing ? (
              <input
                type="text"
                placeholder=""
                name="animal_name"
                className="titer-pvalue practice-the-all-ms"
                value={formData.animal_name}
                onChange={handleChange}
                style={{ fontSize: "14px", width: "100%" }}
              />
              ) : ( 
                <div className="titer-pvalue practice-the-all-ms"  style={{ fontSize: "14px", width: "100%" }}>{formData.animal_name}</div>
              )}
              <div className="flex items-start">
                <label
                  className="text-xl font-semibold"
                  style={{ margin: "5px 0 -1px 0", paddingBottom: "1px" }}
                >
                  Microchip Number
                </label>
                <div className="space-x-2" style={{ display: "flex" }}>
                  {[...Array(5)].map((_, groupIndex) => (
                    <div
                      key={groupIndex}
                      className="border-2 border-gray-300 rounded-md"
                      style={{ display: "flex", padding: "0 10px 0 0" }}
                    >
                      {[...Array(3)].map((_, inputIndex) => (
                        <input
                          key={inputIndex}
                          type="text"
                          maxLength="1"
                          className="text-center border-r-2 border-gray-300 last:border-r-0 focus:outline-none text-lg"
                          style={{
                            width: "22px",
                            height: "22px",
                            borderLeft:
                              inputIndex === 0
                                ? "2px solid black"
                                : "2px solid black", // Apply left border only for the first input
                            borderTop: "2px solid black", // Always apply top border
                            borderBottom: "2px solid black", // Always apply bottom border
                            borderRight:
                              inputIndex === 1
                                ? "0px"
                                : inputIndex === Array.length - 1
                                ? "0px"
                                : "2px solid black", // No right border for inputIndex 1 and the last input
                            padding: "0px 2px 2px 2px ",
                            fontSize: "13px",
                            cursor: isEditing ? "pointer" : "not-allowed",
                          }}
                          name={`${groupIndex * 3 + inputIndex}`} // Name for individual input
                          value={
                            formData.owner_microchip_number.split(",")[
                              groupIndex * 3 + inputIndex
                            ] || ""
                          }
                          onChange={(e) =>
                            handleMicrochipChange(e, groupIndex, inputIndex)
                          } // Handle the change
                          disabled={!isEditing}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex items-start">
                <label
                  className="text-xl font-semibold"
                  style={{ margin: "5px 0 1px 0" }}
                >
                  AVID Microchip Number (if applicable)
                </label>
                <div className="space-x-2" style={{ display: "flex" }}>
                  {[...Array(3)].map((_, groupIndex) => (
                    <div
                      key={groupIndex}
                      className="border-2 border-gray-300 rounded-md"
                      style={{ display: "flex", padding: "0 10px 0 0" }}
                    >
                      {[...Array(3)].map((_, inputIndex) => (
                        <input
                          key={inputIndex}
                          type="text"
                          maxLength="1"
                          className="text-center border-r-2 border-gray-300 last:border-r-0 focus:outline-none text-lg"
                          style={{
                            width: "22px",
                            height: "22px",
                            borderLeft:
                              inputIndex === 0
                                ? "2px solid black"
                                : "2px solid black", // Apply left border only for the first input
                            borderTop: "2px solid black", // Always apply top border
                            borderBottom: "2px solid black", // Always apply bottom border
                            borderRight:
                              inputIndex === 1
                                ? "0px"
                                : inputIndex === Array.length - 1
                                ? "0px"
                                : "2px solid black", // No right border for inputIndex 1 and the last input
                           cursor: isEditing ? "pointer" : "not-allowed",
                          }}
                          name={`${groupIndex * 3 + inputIndex}`} // For each input field
                          value={
                            formData.owner_avid_microchip_number.split(",")[
                              groupIndex * 3 + inputIndex
                            ] || ""
                          }
                          onChange={(e) =>
                            handleAvidMicrochipChange(e, groupIndex, inputIndex)
                          } // Update the field when changed
                          disabled={!isEditing}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ display: "flex", padding: "7px 0 0 0" }}>
                <label style={{ padding: "3px 8px 2px 0", fontSize: "13px" }}>
                  Species
                </label>
                {isEditing ? (
                  <input
                    type="text"
                    placeholder=""
                    name="owner_species"
                    className="titer-pvalue"
                    value={formData.owner_species}
                    onChange={handleChange}
                    style={{
                      fontSize: "14px",
                      width: "84%",
                      border: "2px solid #333",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      fontSize: "14px",
                      width: "84%",
                      border: "2px solid #333",
                    }}
                  >
                    {formData.owner_species}
                  </div>
                )}
              </div>
              <div style={{ display: "flex", padding: "7px 0 0 0" }}>
                <label style={{ padding: "3px 19px 2px 0", fontSize: "13px" }}>
                  Breed
                </label>
                {isEditing ? (
                  <input
                  type="text"
                  placeholder=""
                  name="owner_breed"
                  className="titer-pvalue"
                  value={formData.owner_breed}
                  onChange={handleChange}
                  style={{
                    fontSize: "14px",
                    width: "84%",
                    border: "2px solid #333",
                  }}
                />
                ):(
                  <div className="titer-pvalue" style={{
                    fontSize: "14px",
                    width: "84%",
                    border: "2px solid #333",
                  }}>{formData.owner_breed}</div>
                 )}
                
              </div>

              <div style={{ display: "flex", padding: "7px 0 0 0" }}>
                <label style={{ padding: "3px 30px 2px 0", fontSize: "13px" }}>
                  Age
                </label>
                {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="owner_age"
                  value={formData.owner_age}
                  onChange={handleChange}
                  className="titer-pvalue"
                  style={{
                    fontSize: "14px",
                    width: "42%",
                    paddingRight: "5px",
                    border: "2px solid #333",
                  }}
                />
                ) : ( 
                  <div className="titer-pvalue"
                  style={{
                    fontSize: "14px",
                    width: "42%",
                    paddingRight: "5px",
                    border: "2px solid #333",
                  }}>{formData.owner_age}</div>
                )}
                <div style={{ display: "flex", padding: "0px 0 0 22px" }}>
                  <label
                    style={{ padding: "3px 19px 2px 0", fontSize: "13px" }}
                  >
                    Sex
                  </label>
                  {isEditing ? (
                  <input
                    type="text"
                    placeholder=""
                    name="owner_sex"
                    value={formData.owner_sex}
                    onChange={handleChange}
                    className="titer-pvalue"
                    style={{
                      fontSize: "14px",
                      width: "72%",
                      border: "2px solid #333",
                    }}
                  />
                  ) : (
<div className="titer-pvalue"
    style={{
      fontSize: "14px",
      width: "124.14px",
      border: "2px solid #333",
      marginRight: '5px',
      minHeight: "24px", // Ensure it has enough height when empty
      // display: "flex",
      // alignItems: "center",
      // padding: "2px",
    }}
  >
    {formData.owner_sex}
  </div>
                  )}
                </div>
              </div>

              <label
                style={{
                  fontSize: "14px",
                  padding: "9px 0 3px 0",
                  paddingBottom: "3px",
                }}
              >
                Date of sampling and microchip reading:
              </label>
              {isEditing ? (
              <input
                type="text"
                placeholder=""
                name="owner_date_of_sampling"
                value={formData.owner_date_of_sampling}
                onChange={handleChange}
                className="titer-pvalue practice-the-all-ms1"
                
              />
              ) : (
                <div className="titer-pvalue practice-the-all-ms1"
                >{formData.owner_date_of_sampling}</div>
               )}
              <label style={{ fontSize: "14px", padding: "4px 0 1px 0" }}>
                Date of vaccination
              </label>
              {isEditing ? (
              <input
                type="text"
                placeholder=""
                name="owner_date_of_vaccination"
                value={formData.owner_date_of_vaccination}
                onChange={handleChange}
                className="titer-pvalue practice-the-all-ms1"
                
              />
              ) : ( 
<div className="titer-pvalue practice-the-all-ms1"
                >{formData.owner_date_of_vaccination}</div>
              )}
              <label style={{ fontSize: "14px", padding: "4px 0 1px 0" }}>
                Vaccine manufacturer and batch no:
              </label>
              {isEditing ? (
              <input
                type="text"
                placeholder=""
                name="owner_vaccine_manufacturer"
                value={formData.owner_vaccine_manufacturer}
                onChange={handleChange}
                className="titer-pvalue practice-the-all-ms1"
                
              />
              ) :(
                <div className="titer-pvalue practice-the-all-ms1"
                >{formData.owner_vaccine_manufacturer}</div>
               )}
              <div style={{ display: "flex", padding: "7px 0 0 0" }}>
                <label
                  style={{
                    padding: "3px 8px 2px 0",
                    fontSize: "12px",
                    color: "black",
                  }}
                >
                  Date of Travel{" "}
                  <span style={{ fontSize: "10px" }}>(optional)</span>
                </label>
                {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="owner_date_of_travel"
                  value={formData.owner_date_of_travel}
                  onChange={handleChange}
                  className="titer-pvalue"
                  style={{ fontSize: "14px", width: "65%" }}
                />
                ) : (
<div className="titer-pvalue"
                  style={{ fontSize: "14px", width: "65%" }}>{formData.owner_date_of_travel}</div>
                )}
              </div>
              <div style={{ display: "flex", padding: "7px 0 0 0" }}>
                <label
                  style={{
                    padding: "3px 19px 2px 0",
                    fontSize: "12px",
                    color: "black",
                  }}
                >
                  Destination Country{" "}
                  <span style={{ fontSize: "10px" }}>(optional)</span>
                </label>
                {isEditing ? (
                <input
                  type="text"
                  placeholder=""
                  name="owner_destination_country"
                  value={formData.owner_destination_country}
                  onChange={handleChange}
                  className="titer-pvalue"
                  style={{ fontSize: "14px", width: "53.4%" }}
                />
                ) : (
                  <div className="titer-pvalue"
                  style={{ fontSize: "14px", width: "53.4%" }}>{formData.owner_destination_country}</div>
                 )}
              </div>

              <div style={containerStyle}>
                <div style={textSectionStyle}>
                  <p>
                    Submission details and guidance notes can be found at{" "}
                    <a
                      href="http://apha.defra.gov.uk/vet-gateway/surveillance/forms.htm"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={linkStyle}
                    >
                      http://apha.defra.gov.uk/vet-gateway/surveillance/forms.htm
                    </a>
                  </p>
                </div>
                <div style={logoSectionStyle}>
                  <img src={ukas} alt="UKAS Testing Logo" style={imageStyle} />
                  <p style={certificationTextStyle}>1769</p>
                </div>
              </div>
            </div>
          </section>
          <p style={{ fontSize: "10.64px", padding: "3px 0 0 0" }}>
            VLARAB1
            <span style={{ fontSize: "10px", padding: "0 0 0 4px" }}>
              (Rev. 08/23)
            </span>
          </p>
        </main>
      </div>
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <button onClick={toggleEdit}>{isEditing ? "Save" : "Edit"}</button>
        <button type="submit" onClick={handleSubmit}>
          Submit
        </button>
        <button style={{ marginTop: "1rem" }} onClick={downloadAsPDF}>
          Download as PDF
        </button>
      </div>
    </>
  );
};

// CSS start
const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 0 0 0",
  width: "100%",
};

const textSectionStyle = {
  maxWidth: "71%",
  fontSize: "10.64px",
  lineHeight: 1.2,
  margin: "30px 0 0 0",
  // padding: '30px 0 0 0'
};

const linkStyle = {
  color: "black",
  textDecoration: "underline",
};

const logoSectionStyle = {
  textAlign: "center",
  width: "4rem",
};

const imageStyle = {
  width: "65px",
  padding: "46px 0 0 0",
};

const certificationTextStyle = {
  marginTop: "5px",
  fontSize: "9px",
};

// CSS END

export default TiterForm;
